<template>
  <div
    class="kt-grid kt-grid--ver kt-grid--root kt-page"
    v-if="showLogin"
    style="position:relative"
  >
    <div class="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1" id="kt_login">
      <div
        class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile"
      >
        <!--begin::Aside-->
        <div
          class="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside"
          style="background-image: url(/img/misc/bg-4.jpg);"
        >
          <div class="kt-grid__item">
            <a href="#" class="kt-login__logo">
              <img src="/img/logo-4.png" />
            </a>
          </div>
          <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver">
            <div class="kt-grid__item kt-grid__item--middle">
              <h3 class="kt-login__title">{{$t("Welcome to")}} {{$t('WebsiteName')}}!</h3>
              <h4 class="kt-login__subtitle">{{$t("The ultimate loto management app.")}}</h4>
            </div>
          </div>
          <div class="kt-grid__item">
            <div class="kt-login__info">
              <div
                class="kt-login__copyright"
              >&copy; {{year}} {{$t('WebsiteName')}} ({{$t("updated on")}} {{version}})</div>
              <div class="kt-login__menu">
                <!--a href="#" class="kt-link">{{$t('Privacy')}}</a>
                <a href="#" class="kt-link">{{$t('Legal')}}</a>
                <a href="#" class="kt-link">{{$t('Contact')}}</a-->
              </div>
            </div>
          </div>
        </div>
        <!--begin::Aside-->

        <!--begin::Content-->
        <div
          class="kt-grid__item kt-grid__item--fluid kt-grid__item--order-tablet-and-mobile-1 kt-login__wrapper"
          ref="cnt"
        >
          <b-navbar-nav
            class="ml-auto"
            style="display:inline-block;position:absolute;top:10px;right:20px"
          >
            <LanguageDropdown />
          </b-navbar-nav>
          <!--begin::Body-->
          <div class="kt-login__body">
            <!--begin::Signin-->
            <div class="kt-login__form">
              <div class="kt-login__title">
                <h3>{{$t('Sign in')}}</h3>
              </div>

              <b-alert variant="danger" :show="errShow">{{$t(errMsg)}}</b-alert>

              <!--begin::Form-->
              <form @submit.prevent="onSubmit" class="kt-form" novalidate="novalidate">
                <div class="form-group">
                  <input
                    class="form-control"
                    type="text"
                    v-model="username"
                    :placeholder="$t('Username')"
                    autocomplete="off"
                  />
                </div>
                <div class="form-group">
                  <input
                    class="form-control"
                    type="password"
                    v-model="password"
                    :placeholder="$t('Password')"
                  />
                </div>
                <!--begin::Action-->
                <div class="kt-login__actions">
                  <div>&nbsp;</div>
                  <!--a href="#" class="kt-link kt-login__link-forgot">{{$t('Forgot password?')}}</a-->
                  <button
                    type="submit"
                    class="btn btn-primary btn-elevate kt-login__btn-primary"
                  >{{$t('Sign in')}}</button>
                </div>
                <!--end::Action-->
              </form>
              <!--end::Form-->
            </div>
            <!--end::Signin-->
          </div>
          <!--end::Body-->
        </div>
        <!--end::Content-->
      </div>
    </div>
  </div>
</template>

<script>
import LanguageDropdown from "@/containers/LanguageDropdown";

export const toDate = st => {
  let date_ob;
  if (st) {
    date_ob = new Date(st);
  } else {
    date_ob = new Date();
  }

  // current date
  // adjust 0 before single digit date
  let date = ("0" + date_ob.getDate()).slice(-2);

  // current month
  let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);

  // current year
  let year = date_ob.getFullYear();

  let hours = ("0" + date_ob.getHours()).slice(-2);
  let minutes = ("0" + date_ob.getMinutes()).slice(-2);
  let seconds = ("0" + date_ob.getSeconds()).slice(-2);
  return `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`;
};

export default {
  name: "Login",
  components: {
    LanguageDropdown
  },
  data() {
    return {
      showLogin: false,
      errShow: false,
      errMsg: "",

      username: "",
      password: "",
      year: new Date().getFullYear()
    };
  },
  computed: {
    version() {
      return toDate(process.env.VERSION);
    }
  },
  created() {
    const loader = this.$loading.open({
      container: this.$refs.cnt
    });
    this.$store
      .dispatch("auth/me")
      .then(resp => {
        this.redirectToHome();
      })
      .catch(err => {
        this.showLogin = true;
      })
      .finally(() => {
        loader.close();
      });
  },
  methods: {
    onSubmit() {
      const loginData = {
        username: this.username,
        password: this.password
      };

      this.errShow = false;
      this.errMsg = "";

      const loader = this.$loading.open({
        container: this.$refs.cnt
      });

      this.$store
        .dispatch("auth/login", loginData)
        .then(resp => {
          if (resp.data && resp.data.token) {
            this.redirectTo2fa(resp.data.token);
          } else {
            this.redirectToHome();
          }
        })
        .catch(err => {
          this.errMsg =
            err.details && err.details.length ? err.details[0] : err.message;
          this.errShow = true;
        })
        .finally(() => {
          loader.close();
        });
    },
    redirectToHome() {
      this.$store.dispatch("auth/me");
      this.$router.push("/home");
    },
    redirectTo2fa(token) {
      console.log(`/auth/2fa/${token}`);
      this.$router.push(`/auth/2fa/${token}`);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/metronic/theme/login.scss";
</style>
